G.TextTimer = function (x, y, date, style, anchor, maxWidth, timerFormat, wrapperText = '') {
  G.Text.call(this, x, y, '???', style, anchor, maxWidth);

  this.secLeft = 0;
  this.active = false;
  this.timerFormat = timerFormat || 'hms';
  this.wrapperText = wrapperText;

  this.dots = true;

  this.timerBinding = G.sb('onWallClockTimeUpdate')
    .add(this.updateTimer, this);

  this.events.onDestroy.add(() => {
    this.active = false;
    this.timerBinding.detach();
  }, this);

  if (date) {
    this.setDate(date);
  }
};

G.TextTimer.prototype = Object.create(G.Text.prototype);

G.TextTimer.prototype.sfx = null;

G.TextTimer.prototype.updateTimer = function() {
  if (!this.active) return;
  if (this.sfx) this.sfx.play();

  this.secLeft = Math.max(0, this.secLeft - 1);
  this.updateTimerText(this.secLeft, this.dots);
  this.dots = !this.dots;
};

G.TextTimer.prototype.setSecLeft = function(secLeft) {
  secLeft = parseInt(secLeft, 10);
  this.secLeft = Math.max(0, secLeft);
  this.updateTimerText(this.secLeft, true);
};

G.TextTimer.prototype.updateTimerText = function(secLeft, dots) {
  let dataArray;
  if (this.timerFormat === 'hms') {
    dataArray = G.changeSecToHMS(this.secLeft);
  } else if (this.timerFormat === 'ms') {
    dataArray = G.changeSecToMS(this.secLeft);
  } else {
    dataArray = G.changeSecToDHMS(this.secLeft);
  }
  dots = true;
  if (this.wrapperText !== '') {
    this.setText(this.wrapperText.replace('%TIME%', dataArray.join(dots ? ':' : ' ')));
  } else {
    this.setText(dataArray.join(dots ? ':' : ' '));
  }
};

G.TextTimer.prototype.start = function(secLeft) {
  if (secLeft) {
    secLeft = parseInt(secLeft, 10);
    this.setSecLeft(secLeft);
  }
  this.active = true;
};

G.TextTimer.prototype.setDate = function(dateString) {
  const ms = new Date(dateString).getTime();
  const now = Date.now();
  const diffSec = Math.ceil((ms - now) / 1000);
  this.setSecLeft(diffSec);
  this.active = true;
};
